<template>
    <div>
        <div class="themes-style">
            <h5 class="mb-4">Theme Settings</h5>
            <div class="category-themes">
                <button :class="active_theme_category === data.value ? 'btn-primary' : 'btn-outline-info'"
                        class="btn mr-3 mb-4"
                        @click="active_theme_category = data.value"
                        v-for="(data,index) in events_type"
                        :key="index">
                        {{data.label}}
                </button>
            </div>
            <b-card class="bdr-15 card-style" :class="active_theme_category !== '' ? 'checked-cat' : ''">
                <div class="row-themes">
                    <div :class="[ detail_event.theme_id === data.id ? 'active' : '' ,active_theme_category === data.type ? '' : 'hide', data.agent_id && user.id !== data.agent_id ? 'd-none' : '']"
                         class="mb-1 themes"
                         v-for="data in themes"
                         :key="data.id" v-on:click="_changeTheme(data.id)"
                    >
                        <div class="pic">
                            <b-img-lazy v-if="data.photo_thumb" class="w-100" :src="data.photo_thumb"></b-img-lazy>
                        </div>

                        <div class="pic-content">
                            <div class="style-label">{{data.name}}</div>
                            <div style="color: #c0bfbf;" class="style-label mt-0">{{data.type}}</div>
                            <div class="new-label" v-if="Date.parse(data.created_at) > Date.now() - (15 * 1000 * 60 * 60 * 24)">New</div>
                        </div>

                        <div class="zoom-wrapper" v-on:click.stop="">
                            <div class="w-100" @click.prevent="openThemeZoom(data.photo)">
                                <i class="uil uil-search"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>

        <b-modal ref="modal-Theme" hide-header hide-footer>
            <div class="close-modal-t" @click="$refs['modal-Theme'].hide()">
                <i class="uil uil-times-circle"></i>
            </div>
            <b-img-lazy class="w-100" :src="theme_choose"></b-img-lazy>
        </b-modal>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    export default{
        props:{
            detail_event:{
                type: Object,
                required: true,
            },
        },
        data(){
            return{
                active_theme_category:'',
                theme_choose:'',
            }
        },
        computed:{
            ...mapState('EventsControl', {
                themes: state => state.themes,
                events_type: state => state.events_type,
            }),
            ...mapState('AuthControl', {
                user: state => state.user,
            }),
        },
        methods:{
            ...mapActions('EventsControl', ['changeTheme']),

            openThemeZoom(img){
                this.$refs['modal-Theme'].show()
                this.theme_choose = img
            },
            _changeTheme(id){
                this.changeTheme(id)
                this.$toast.success('Successfully Update Event')
            }

        }

    }

</script>
